<template>
  <div>
    <div class="banner1-wrapper">
      <div class="banner-anim">
        <transition-group name="banner-fade" tag="div" class="banner-items">
          <div class="banner-item " key="0">
            <div class="banner-bg">
              <img :src="bannerImg" />
            </div>
            <div class="banner-text-wrapper">
              <div class="banner-title">
                <img :src="logoImg" width="136" alt="湖北泰跃卫星技术发展股份有限公司LOGO" />
              </div>
              <div class="banner-content">
                <img :src="t1Img" width="691"/>
              </div>
              <div class="banner-content">
                <img :src="t2Img"  width="618"/>
            </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <div class="banner1-icon">
      <span class="down-icon" @click="scrollDown">▼</span>
    </div>
  </div>
</template>

<script>
import logoImg from '@/assets/logo_light.png'
import t1Img from '@/assets/t1.png'
import t2Img from '@/assets/t2.png'
import bannerImg from '@/assets/banner1.png'

export default {
  name: 'Banner2',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      props: {},
      logoImg,
      t1Img,
      t2Img,
      bannerImg,
    }
  },
  mounted() {
    // 初始化props
    this.props = { ...this.$props }
    delete this.props.isMobile
  },
  methods: {
    scrollDown() {
      // 页面向下滚动一屏
      window.scrollBy({ top: window.innerHeight, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.banner1-wrapper {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.banner-anim {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner-items {
  width: 100%;
  height: 100%;
}

.banner-item {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.banner-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-text-wrapper {

  display: block;
  position: relative;
  top: -10%;
  left: 0;
  right: 0;
  margin: auto;
  font-size: 14px;
  color: #fff;
  text-align: center;
  transform: scale(1.2);
}

.banner-title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 20px;
  opacity: 0;
  animation: fadeInUp 1s ease-out 0.2s forwards;
}

.banner-content {
  margin-bottom: 30px;
  opacity: 0;
  animation: fadeInUp 1s ease-out 0.4s forwards;
}

.banner-content img {
  max-width: 100%;
  height: auto;
}

.banner1-icon {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  animation: bounce 2s infinite;
}

.down-icon {
  font-size: 24px;
  color: #fff;
}

/* 动画效果 */
.banner-fade-enter-active,
.banner-fade-leave-active {
  transition: opacity 1s ease;
}

.banner-fade-enter,
.banner-fade-leave-to {
  opacity: 0;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateX(-50%) translateY(0);
  }
  40% {
    transform: translateX(-50%) translateY(-20px);
  }
  60% {
    transform: translateX(-50%) translateY(-10px);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .banner-title {
    font-size: 24px;
  }
  
  .banner-content img {
    max-width: 90%;
  }
}
</style>